'use strict';

const $ = require('jquery');

var SELECTORS = {
    container: '.js-background-video',
    video: '.js-background-video__video',
    btn: '.js-background-video__button'
};
var supportedFormats = {
    'mp4': 'video/mp4'
};

var autoPlay = true;
var pauseClass = 'is-paused';
var stoppedClass = 'is-stopped';
var playingClass = 'is-playing';
var hasVideoClass = 'has-video';

function init() {
    var container = $(SELECTORS.container);
    var video = $(SELECTORS.video);
    var btn = $(SELECTORS.btn);
    var videoUrl = container.data('url');

    var initialised = false;

    var canRun = (
        videoUrl &&
        container.length &&
        video.length
    );

    if (!canRun) {
        return;
    }

    var formatExt, srcTag;
    for (formatExt in supportedFormats) {
        if (supportedFormats.hasOwnProperty(formatExt)) {
            srcTag = document.createElement('source');
            srcTag.src = videoUrl.replace(/\.\w+$/, '.' + formatExt);
            srcTag.type = supportedFormats[formatExt];
            video.append(srcTag);
        }
    }

    updatePlayPauseClasses(video, btn);
    video.on('canplaythrough', function() {
        if (!initialised) {
            if (autoPlay) {
                playVideo(container, video, btn);
            }

            container.addClass(hasVideoClass);
            updatePlayPauseClasses(video, btn);
            initialised = true;
        }
    });

    video.on('ended', function() {
        stopVideo(container, video, btn);
    });

    btn.on('click', function() {
        if ( video[0].paused ) {
            playVideo(container, video, btn);
        } else {
            pauseVideo(video, btn);
        }

        updatePlayPauseClasses(video, btn);
    });
}

function updatePlayPauseClasses(video, btn) {
    if ( video[0].paused || video[0].stopped ) {
        btn.addClass(pauseClass);
        video.addClass(pauseClass);
        video.removeClass(playingClass);
    } else {
        btn.removeClass(pauseClass);
        video.removeClass(pauseClass);
        video.addClass(playingClass);
    }
}

function playVideo(container, video, btn) {
    video[0].play();
    updatePlayPauseClasses(video, btn);
    container.removeClass(stoppedClass);

}

function pauseVideo(video, btn) {
    video[0].pause();
    updatePlayPauseClasses(video, btn);
}

function stopVideo(container, video, btn) {
    var videoEl = video[0];
    // Pause initially, fade video out
    videoEl.pause();
    autoPlay = false;
    updatePlayPauseClasses(video, btn);
    container.addClass(stoppedClass);

    // Only reset video after a delay to prevent flashing
    setTimeout(function() {
        video.load();
    }, 2000);
}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./modules/pageHeroVideo.js